import { Component, OnInit, Injectable } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { ApiService } from '../../../../core/services/api.service';
import { TutorialService } from '../tutorial.service';
import { GeneralService } from '../../../services/general.service';
import { saveAs } from 'file-saver/FileSaver';
@Component({
  selector: 'app-device-manual',
  templateUrl: './device-manual.component.html',
  styleUrls: ['./device-manual.component.scss']
})

export class DeviceManualComponent implements OnInit {

  constructor(private sesionStateService: SessionStateService,
              private generalService: GeneralService,
              private apiService: ApiService)  { }

  ngOnInit() {
  }

  getBoxManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_box_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_box_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_box_EN.PDF';
    }

    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_box_'.concat(this.sesionStateService.getLang()));
      }
    );
  }

  getMeterManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_meter_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_meter_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_meter_EN.PDF';
    }

    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_meter_'.concat(this.sesionStateService.getLang()));
      }
    );
  }

  getPlugAcManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_plug_ac_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_plug_ac_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_plug_ac_EN.PDF';
    }
    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_plug_ac_'.concat(this.sesionStateService.getLang()));
      }
    );
  }

  getPlugManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_plug_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_plug_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_plug_EN.PDF';
    }

    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_plug_'.concat(this.sesionStateService.getLang()));
      }
    );
  }

  getPlugSolarManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_plug_solar_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_plug_solar_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_plug_solar_EN.PDF';
    }

    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_plug_solar_'.concat(this.sesionStateService.getLang()));
      }
    );
  }

  getSwitchManual() {
    let url;
    if (this.sesionStateService.getLang() === 'PT') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/PT/redy_switch_PT.PDF';
    } else if (this.sesionStateService.getLang() === 'ES') {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/ES/redy_switch_ES.pdf';
    } else {
      url = 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/RedyManuals/EN/redy_switch_EN.PDF';
    }
    this.generalService.downloadPDF(url).subscribe(
      (res) => {
          saveAs(res, 'redy_switch_'.concat(this.sesionStateService.getLang()));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tutorial/device-manual/device-manual.component.ts